import React from 'react';
import { Route, IndexRoute } from 'react-router';
import BCApp from '../components/BCApp';
import Dashboard from '../components/Dashboard';
import NotFound from '@bibliocommons/not-found';
import PrintLayout from '@bibliocommons/layouts-print';
import WidgetLayout from '../components/layouts/WidgetLayout';
import UserContainer from '../containers/UserContainer';
import AvailabilityDetailsContainer from '../containers/AvailabilityDetailsContainer';
import BCAppContainer from '../containers/BCAppContainer';
import LoginContainer from '../containers/LoginContainer';
import SearchContainer from '../containers/SearchContainer';
import ShelfContainer from '../containers/ShelfContainer';
import PrintSearchContainer from '../containers/print/PrintSearchContainer';
import PrintCheckedOutContainer from '../containers/print/PrintCheckedOutContainer';
import PrintHoldsContainer from '../containers/print/PrintHoldsContainer';
import PrintShelfContainer from '../containers/print/PrintShelfContainer';
import FeatureToggleContainer from '../containers/FeatureToggleContainer';
import ItemWidgetContainer from '../containers/widgets/ItemWidgetContainer';
import UGCTestLayout from '../components/UGCTestLayout';
import InternalError from '../components/InternalError';
import BorrowingLayout from '../components/borrowing/shared/BorrowingLayout';
import AuthenticatedRoute from '../components/shared/AuthenticatedRoute';
import AccountRequiredRouteContainer from '../containers/AccountRequiredRouteContainer';
import CheckedOutContainer from '../containers/CheckedOutContainer';
import FinesContainer from '../containers/FinesContainer';
import HoldsContainer from '../containers/HoldsContainer';
import MessagesContainer from '../containers/MessagesContainer';
import InterlibraryLoansContainer from '../containers/InterlibraryLoansContainer';
import RecentlyReturnedContainer from '../containers/RecentlyReturnedContainer';
import PrintRecentlyReturnedContainer from '../containers/print/PrintRecentlyReturnedContainer';

export default basePath => (
  <Route path={`${basePath}/`} component={BCAppContainer}>
    <Route path="print" component={PrintLayout}>
      <Route path="search" component={PrintSearchContainer} />
      <Route path="users/:userId" component={UserContainer}>
        <Route path="shelves/:shelfName" component={PrintShelfContainer} />
      </Route>
      <Route component={AuthenticatedRoute}>
        <Route component={AccountRequiredRouteContainer}>
          <Route path="checkedout" component={PrintCheckedOutContainer} />
          <Route path="holds" component={PrintHoldsContainer} />
          <Route path="recentlyreturned" component={PrintRecentlyReturnedContainer} />
        </Route>
      </Route>
    </Route>
    <Route path="widgets" component={WidgetLayout}>
      <Route path="item/:metadataId" component={ItemWidgetContainer} />
    </Route>
    <Route path="ugctest" component={UGCTestLayout} />
    <Route component={BCApp}>
      <Route path="dashboard" component={Dashboard} />
      <Route path="search" component={SearchContainer}>
        <Route path="availability/:metadataId" component={AvailabilityDetailsContainer} />
      </Route>
      <Route path="users/:userId" component={UserContainer}>
        <Route path="shelves/:shelfName" component={ShelfContainer}>
          <Route path="availability/:metadataId" component={AvailabilityDetailsContainer} />
        </Route>
        <Route path="lists/:listId" component={NotFound} />
        <Route path="activity-feed" component={NotFound} />
        <Route path="news-feed" component={NotFound} />
        <Route path="following" component={NotFound} />
        <Route path="followers" component={NotFound} />
      </Route>
      <Route component={AuthenticatedRoute}>
        <Route component={UserContainer}>
          <Route path="shelves/:shelfName" component={ShelfContainer}>
            <Route path="availability/:metadataId" component={AvailabilityDetailsContainer} />
          </Route>
          <Route path="lists/:listId" component={NotFound} />
          <Route path="activity-feed" component={NotFound} />
          <Route path="news-feed" component={NotFound} />
          <Route path="following" component={NotFound} />
          <Route path="followers" component={NotFound} />
        </Route>
        <Route component={AccountRequiredRouteContainer}>
          <Route component={BorrowingLayout}>
            <Route path="checkedout" component={CheckedOutContainer} />
            <Route path="checkedout/:status" component={CheckedOutContainer} />
            <Route path="holds" component={HoldsContainer}>
              <Route path="availability/:metadataId" component={AvailabilityDetailsContainer} />
            </Route>
            <Route path="holds/:status" component={HoldsContainer} >
              <Route path="availability/:metadataId" component={AvailabilityDetailsContainer} />
            </Route>
            <Route path="fines" component={FinesContainer} />
            <Route path="recentlyreturned" component={RecentlyReturnedContainer} />
            <Route path="accountmessages" component={MessagesContainer} />
            <Route path="interlibraryloans" component={InterlibraryLoansContainer} />
            <Route path="interlibraryloans/:status" component={NotFound} />
          </Route>
        </Route>
      </Route>
      <Route path="availability/:metadataId" component={AvailabilityDetailsContainer} />
      <Route path="login" component={LoginContainer} />
      <Route path="feature-toggles" component={FeatureToggleContainer} />
      <Route path="500_client" component={InternalError} />
      <IndexRoute component={Dashboard} />
      <Route path="*" component={NotFound} />
    </Route>
  </Route>
);



// WEBPACK FOOTER //
// ./app/routes/Routes.jsx